import { Box, Typography } from "@mui/material";
import ShopSquareView from "../ShopItemView/ShopSquareView";
import { ShopShirtInterface } from "../../services/shirts/types";

interface ShopItemsListProps {
  shirts: Array<ShopShirtInterface>;
  total: number;
}

const ShopItemsList = ({ shirts, total }: ShopItemsListProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        paddingBottom: 5,
      }}
    >
      <Typography
        variant="whyText"
        sx={{
          fontWeight: "500 !important",
          color: "#6f7d95 !important",
          fontSize: "1rem !important",
          textAlign: "left !important",
          marginY: "1rem",
        }}
      >
        {total} results
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          rowGap: 2,
          justifyContent: "flex-start",
        }}
      >
        {shirts.map((s, index) => (
          <Box
            key={index}
            sx={{
              flex: "1 1 100%",
              maxWidth: { xs: "100%", md: "25%" },
              paddingX: { xs: 0, md: 1 },
            }}
          >
            <ShopSquareView shirt={s} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ShopItemsList;
